const Asterisk = () => {
    return (
        <span className="text-danger ms-1">*</span>
    )
}

export default Asterisk